import { Injectable } from '@angular/core'
import * as toastr from 'toastr';
//declare the global object so typescript will not complain about it
//declare let toastr:any

//with Injectable angular knows about the service
//this is a injectable toastr service
@Injectable()
export class ToastrService {
    success(message: string, title?: string) {

        this.setOptions();

        if (typeof title != 'undefined' && title) {
            toastr.success(message, title)
        }
        else {
            toastr.success(message);
        }
        
        
    }
    info(message: string, title?: string) {
        this.setOptions();

        if (typeof title != 'undefined' && title) {
            toastr.info(message, title)
        }
        else {
            toastr.info(message);
        }
    }
    warning(message: string, title?: string) {
        this.setOptions();
        if (typeof title != 'undefined' && title) {
            toastr.warning(message, title)
        }
        else {
            toastr.warning(message);
        }
       
    }
    error(message: string, title?: string) {
        this.setOptions();
        if (typeof title != 'undefined' && title) {
            toastr.error(message, title)
        }
        else {
            toastr.error(message);
        }
    }

    setOptions() {
        toastr.options.timeOut = 3000; 
        toastr.options.extendedTimeOut = 6000; 
        toastr.options.progressBar = true;
        toastr.options.preventDuplicates = true;
    }
}